import { SystemMessage } from 'components/Dialogue';
import LazyItemMessage from '../LazyItemMessage';
import { BaseSysMsgProps } from './types';
import { memo } from 'react';

export const SysUserEnterFromItemMsg = memo((props: BaseSysMsgProps) => {
  const { raw, conversation } = props;
  const { sysUserEnterFromItemContent } = raw;

  if (!sysUserEnterFromItemContent || !conversation) {
    return null;
  }

  const { externalStoreId, externalItemId } = sysUserEnterFromItemContent;
  const { storeId } = conversation;

  return (
    <SystemMessage>
      <LazyItemMessage
        isUserEnter
        rawMsg={raw}
        storeId={storeId}
        externalItemId={externalItemId}
        externalStoreId={externalStoreId}
      />
    </SystemMessage>
  );
});
